import { useRef, useState, useEffect } from "react";
import baseUrl from "../../url/baseUrl";

const degree = 10440;

const Wheel = ({ onSpinResult }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [remainingSpins, setRemainingSpins] = useState(0);
  const innerWheelRef = useRef(null);

  const sections = [
    { prize: "Balo Mễ Mễ" },
    { prize: "Túi vải đay" },
    { prize: "Balo khủng long" },
    { prize: "Mãy lọc không khí mini" },
    { prize: "Túi vải bỉm sữa" },
    { prize: "Bộ 6 cốc thủy tinh Mễ Mễ" },
    { prize: "Balo tiên cá" },
    { prize: "Quạt tích điện cầm tay" },
    { prize: "Mũ cờ đỏ sao vàng" },
    { prize: "Yếm silicon" },
    { prize: "Nhiệt kế hồng ngoại" },
    { prize: "Tất tập bò cho bé" },
    { prize: "Hộp bút chì hoạt hình" },
    { prize: "Dụng cụ uống thuốc cho bé" },
    { prize: "Ô trẻ em" },
  ];

  const fetchRemainingSpins = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/remaining-spins`);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Không lấy được số lượt quay còn lại");
      }

      setRemainingSpins(data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchRemainingSpins();

    const intervalId = setInterval(() => {
      fetchRemainingSpins();
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleSpin = async () => {
    if (isSpinning) return;

    if (remainingSpins <= 0) {
      alert("Tất cả phần quà đã hết, trò chơi đã kết thúc!");
      return;
    }

    setIsSpinning(true);

    try {
      const response = await fetch(`${baseUrl}/api/spin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        setIsSpinning(false);
        alert(data.message || "Không thể quay thưởng");
        fetchRemainingSpins();
        return;
      }

      const selectedPrize = data.prize;

      const selectedIndex = sections.findIndex(
        (section) => section.prize === selectedPrize,
      );

      if (selectedIndex === -1) {
        setIsSpinning(false);
        alert("Không tìm thấy giải thưởng trên vòng quay");
        return;
      }

      setRemainingSpins((prev) => Math.max(prev - 1, 0));

      const sectionAngle = 360 / sections.length;
      const minDegree = selectedIndex * sectionAngle;
      const extraDegree = minDegree + sectionAngle / 2;
      const totalDegree = degree + (360 - extraDegree);

      innerWheelRef.current.style.transition =
        "transform 6s cubic-bezier(0, .99, .44, .99)";

      innerWheelRef.current.style.transform = `rotate(${totalDegree}deg)`;

      setTimeout(() => {
        const resultMessage = {
          prize: selectedPrize,
        };

        onSpinResult(resultMessage);

        innerWheelRef.current.style.transition = "none";
        innerWheelRef.current.style.transform = `rotate(${
          (360 - extraDegree) % 360
        }deg)`;

        setIsSpinning(false);

        fetchRemainingSpins();
      }, 6200);
    } catch (error) {
      console.error(error);
      setIsSpinning(false);
      alert("Lỗi kết nối server");
      fetchRemainingSpins();
    }
  };

  return (
    <>
      <div
        className="text-center"
        style={{ maxWidth: "700px", margin: "0 auto" }}
      >
        <img
          src="/images/game/ribbonlogo.png"
          alt="ribbon_logo"
          className="w-100 vibratelogo"
        />
      </div>

      <div id="wheel" className="col-12">
        <div id="inner-wheel" ref={innerWheelRef}>
          {sections.map((section, index) => (
            <span
              key={section.prize}
              className="wheel-label"
              style={{ "--i": index }}
            >
              {section.prize}
            </span>
          ))}
        </div>

        <div id="spin" onClick={handleSpin}>
          <div id="inner-spin">
            <img
              src="/images/about/logo192.png"
              alt="spin"
              className="spin-image"
            />
          </div>
          <div id="indicator"></div>
        </div>
      </div>

      <div className="text-center mt-3">
        <div className="badge bg-warning text-dark fs-5 px-4 py-3">
          Số lượt quay còn lại:{" "}
          <span className="text-primary">{remainingSpins}</span>
        </div>
      </div>

      <div data-aos="fade-up" className="text-center">
        <img
          src="/images/about/turtle.png"
          alt="ribbon"
          className="w-100 vibratelogo"
          style={{ maxWidth: "120px" }}
        />
      </div>
    </>
  );
};

export default Wheel;
